<div class="card card-login">
  <div class="card-content">
    <able-loading [showLoading]="showLoading"></able-loading>

    <div *ngIf="!showLoading">
      <div class="row">
        <div class="container-fluid">
          <div class="login-header text-center">
            <img [src]="this.logoPath" class="logo" alt="able+" title="able+"/>
            <h3>Changing Device Request</h3>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <p class="text-center" *ngIf='answer&&changeConfirmed'>Change confirmed.</p>
        <p class="text-center" *ngIf='!answer&&changeConfirmed'>No change made.</p>
        <p class="text-center" *ngIf='!changeConfirmed'>Sorry, this link has expired.</p>
      </div>

    </div>
  </div>
</div>
